import { Card, CardBody, Button } from '@heroui/react';
import React from 'react';
import { IconType } from 'react-icons';

export interface EmptyStateProps {
  /** Icon to display (from react-icons) */
  icon: IconType;
  /** Icon background color class (e.g., 'bg-primary-50', 'bg-success-50') */
  iconBgClass?: string;
  /** Icon color class (e.g., 'text-primary-500', 'text-success-500') */
  iconColorClass?: string;
  /** Title text */
  title: string;
  /** Description text */
  description: string;
  /** Optional action button configuration */
  action?: {
    label: string;
    onClick: () => void;
    icon?: IconType;
  };
  /** Whether to show the card container */
  showCard?: boolean;
  /** Additional class names for the container */
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  iconBgClass = 'bg-primary-50',
  iconColorClass = 'text-primary-500',
  title,
  description,
  action,
  showCard = true,
  className,
}) => {
  const content = (
    <div
      className={`flex flex-col items-center justify-center py-12 text-default-500 ${
        className || ''
      }`}
    >
      <div className={`mb-4 p-4 rounded-full ${iconBgClass}`}>
        <Icon size={48} className={iconColorClass} />
      </div>
      <div className="text-xl font-semibold mb-2 text-default-700">{title}</div>
      <div className="text-default-500 text-center max-w-md">{description}</div>
      {action && (
        <Button
          color="primary"
          className="mt-4"
          startContent={action.icon && <action.icon size={16} />}
          onPress={action.onClick}
        >
          {action.label}
        </Button>
      )}
    </div>
  );

  if (!showCard) {
    return content;
  }

  return (
    <Card>
      <CardBody>{content}</CardBody>
    </Card>
  );
};
